import React from 'react';
import { Campaign, Collab } from '@foodfluence/shared';
import ModalShell from '../../../../components/ui/ModalShell';
import CounterCollabForm from './CounterCollabForm';

interface CounterOfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  collab: Collab;
  campaign: Campaign;
  reason?: string;
}

/** The Counter Offer page's form in a modal, for countering without leaving the chat. */
const CounterOfferModal: React.FC<CounterOfferModalProps> = ({ isOpen, onClose, collab, campaign, reason }) => (
  <ModalShell isOpen={isOpen} onClose={onClose} title="Counter offer">
    <CounterCollabForm collab={collab} campaign={campaign} reason={reason} onSubmitted={onClose} />
  </ModalShell>
);

export default CounterOfferModal;
